
import { IDetailArticle } from 'blog'
import { formatDate } from '@/utils'
import { codeStyleMixins } from "@/mixins"
import Vue, { nextTick } from 'vue'
import { highlightAll } from 'prismjs';
import { faCalendar, faComment, faEye } from '@fortawesome/free-regular-svg-icons';

import SvgIcon from '@/components/svgIcon/index.vue'

export default Vue.extend({
	props: {
		article: {
			default: () => null as IDetailArticle
		},
	},

	mixins: [codeStyleMixins],
	methods: {
		formatDate,
		// handleWheel() {
		// 	// console.log("ww");
		// 	// console.log(this.$eventBus);
		// 	this.$eventBus.emit("contentScroll")
		// }
	},
	components: {
		SvgIcon
	},
	watch: {
		'article.htmlContent': {
			handler(n) {
				// console.log(n);

				n && nextTick().then(() => {
					// console.log(this.$el.querySelector('iframe'));
					highlightAll()
				})

			},
			immediate: true
		}
	},
	computed: {
		date: () => faCalendar,
		view: () => faEye,
		comment: () => faComment
	}


})
